import axios from 'axios';
import React, { useContext } from 'react'
import { toast } from 'react-toastify';
import { Cartcontext } from '../Cartcontext';
import { WishlistContext } from '../WishContext';

export default function WishListProduct({Wishproduct , RemoveProductWish  }) {
    const {cart ,setcart} = useContext(Cartcontext)
    const { removeFromWishlist  } = useContext(WishlistContext );

    async function addProductToCart(Product_id) {
    const { data } = await axios.post('https://ecommerce.routemisr.com/api/v1/cart?', { productId: Product_id }, {
        headers: { token: localStorage.getItem('token') }
    })
    RemoveProductWish(Product_id)
    toast.success("it has been successfuly added  🛺​​", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",

    });
    setcart(data)
}  
  return (
    <div>
       <div className="Wish-product rounded-2 my-3">

        <div className="row align-items-center">

          <div className="col-md-2">
               <img className='w-100' src={Wishproduct.imageCover} alt="" />
             </div>
             <div className="col-md-8">
             <p>{Wishproduct.title}</p>
             <p className='text-success'>{Wishproduct.price} EGP</p>
             <button className='btn btn-sm m-0 p-0 text-danger' onClick={()=>{
                  RemoveProductWish(Wishproduct._id);
                  removeFromWishlist(Wishproduct._id)
             }} ><i className ="fa fa-trash px-2"></i>Remove</button>

             </div>
             <div className="col-md-2">
                <button className='btn btn-success'onClick={()=>{addProductToCart(Wishproduct._id)}}> add to cart </button>
             </div>
             </div>
       </div>
    </div>
  )
}
